
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("mealplanner/page_mealplanner_nc",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<flexcol style=\"height:100vh;\"><flexcenter class=\"V4 fw-marginhalf-responsive\"><span id=\"weekdisplay\"></span></flexcenter><flexauto style=\"overflow-x:hidden;overflow-y:auto;font-size: 80%;\" id=\"planner-pane\"></flexauto></flexcol> ";
},"useData":true});
export default TPL;